<template>
  <vx-card no-shadow>
    <vs-input type="password" class="w-full" @input="oldPassword()" label="현재 비밀번호" placeholder="현재 비밀번호" v-model="old_password"/>
    <span id="oldPassword"/><br/>
    <vs-input type="password" class="w-full" @input="newPassword()" label="새 비밀번호" placeholder="새 비밀번호" v-model="new_password"/>
    <span id="newPassword"/><br/>
    <vs-input type="password" class="w-full" @input="checkPassword()" label="새 비밀번호 확인" placeholder="새 비밀번호 확인" v-model="confirm_new_password"/>
    <span id="same"/>
    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <!-- <vs-button class="ml-auto mt-2">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
      <vs-button class="ml-auto mt-2" @click="save()" v-model="saveVal">저장</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">초기화</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      old_password: "",
      new_password: "",
      confirm_new_password: "",
      saveVal: false
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods: {
    save () {
      if (this.saveVal == true && this.old_password !== '' && this.validatePassword(this.new_password) == true) {
        const payload = {
          email: this.activeUserInfo.email,
          password: this.old_password,
          newPassword: this.new_password
        }
        this.$store.dispatch('auth/changePassword', payload).then(()=>{
            this.$vs.notify({
             color: 'success',
             title: '비밀번호가',
             text: '변경되었습니다.'
           })
           this.old_password = ""
           this.new_password = ""
           this.confirm_new_password = ""
         }).catch(() => {
           this.$vs.notify({
             color: 'danger',
             title: 'error',
             text: '비번번호를 다시 확인해주십시오.'
           })
         })
      } else {
        this.$vs.notify({
         color: 'danger',
         title: 'error',
         text: '비번번호를 다시 확인해주십시오.'
       })
      }
      // const payload = {
      //   new_password: this.new_password
      // }
      // this.$store.dispatch('auth/changUserPassword', payload)
      // localStorage.setItem("filleduToken", this.new_password)
    },
    validatePassword(character) {
        return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/.test(character)
        // return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/.test(character)
    },
    oldPassword () {
      if (this.old_password == '') {
        document.getElementById('oldPassword').innerHTML = '입력해주십시오.'
        document.getElementById('oldPassword').style.color = 'red'
      } else {
        // document.getElementById('oldPassword').innerHTML = '입력.'
        // document.getElementById('oldPassword').style.color = 'blue'
      }
    },
    newPassword () {
      if (this.new_password.length < 7 || this.new_password.length > 15) {
        document.getElementById('newPassword').innerHTML='7글자 미만, 15글자 초과할 수 없습니다.'
        document.getElementById('newPassword').style.color='red'
      }
      if (this.validatePassword(this.new_password) == true) {
        document.getElementById('newPassword').innerHTML = '사용이 가능합니다.'
        document.getElementById('newPassword').style.color = 'blue'
        this.saveVal = true
      } else {
        document.getElementById('newPassword').innerHTML = '특수문자, 숫자, 영어를 조합하여 작성해주세요.'
        document.getElementById('newPassword').style.color = 'red'
        this.saveVal = false
      }
    },
    checkPassword () {
      if(!this.new_password){
        return
      }
      if (this.new_password == this.confirm_new_password) {
        document.getElementById('same').innerHTML='비밀번호가 일치합니다.'
        document.getElementById('same').style.color='blue'
        this.saveVal = true
      }
      else {
        document.getElementById('same').innerHTML='비밀번호가 일치하지 않습니다.'
        document.getElementById('same').style.color='red'
        this.saveVal = false
      }
    }
  }
}
</script>
